import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PieChartConfig } from '../../../../../shared/google-chart/Models/PieChartConfig';

@Component({
	selector: 'app-battery-remaining-warranty',
	templateUrl: './battery-remaining-warranty.component.html',
	styleUrls: ['./battery-remaining-warranty.component.css']
})
export class BatteryRemainingWarrantyComponent implements OnInit, OnChanges {

	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	config: PieChartConfig;
	tableColumns: any[] = [];

	constructor() { }

	ngOnInit() {
	
		this.config = new PieChartConfig({
			colors: [
				{ color: '#bd2f26' },
				{ color: '#3f69ec' },
				{ color: '#ff9900' },
				{ color: 'purple' },
				{ color: '#109618' }
			]
		});
		
		this.config.formatFunction = (data) => {
			let formattedData: any[] = [
				[
					{"label": "Name", "type": "string"},
					{"label": "Value", "type": "number"}
				]
			];

			formattedData.push([
				{v: "Less than a year"},
				{v: data.Pie[0].value}
			]);
			formattedData.push([
				{v: "1 year"},
				{v: data.Pie[1].value}
			]);
			formattedData.push([
				{v: "2 years"},
				{v: data.Pie[2].value}
			]);
			formattedData.push([
				{v: "3 years"},
				{v: data.Pie[3].value}
			]);
			formattedData.push([
				{v: "More than 4 years"},
				{v: data.Pie[4].value}
			]);
			return formattedData;
		};
	}
	
	ngOnChanges(changes) {
		if(this.data) {
			let tableColumns = [{title: "Battery ID", property: "battery_id"}];
			if (this.data.siteSettings.userSettings.view_truck_id) {
				tableColumns.push({title: "Truck ID", property: "truck_id"});
			}
			tableColumns.push(
				{title: "Warranted Ahrs", property: "warranted_ahrs"},
				{title: "Remaining Ahrs", property: "remaining_ahrs"},
				{title: "Warranted Yrs", property: "warranted_yrs"},
				{title: "Remaining Yrs Based on Usage", property: "remaining_yrs_ahr"},
				{title: "Remaining Yrs", property: "remaining_yrs"},
				{title: "Battery SN", property: "battery_sn"}
			);
			this.tableColumns = tableColumns;
		}
	}
}
